import React from 'react';
import { Box, Text, Link, SimpleList } from 'edenred-ui';
import { useTheme } from 'styled-components';

import { SupportLinksProps } from '@epi-models/pages/Support';

const linksMapper = data =>
  data.map(elem => {
    if (elem?.links) {
      const links = elem.links.map(({ url, name, id }) => (
        <Link
          target="_blank"
          href={url}
          key={url}
          isSizeMedium
          isFontRegularBold
          id={`support-page-link-element-${id}`}
        >
          {name}
        </Link>
      ));
      return { ...elem, links };
    }
    return elem;
  });

export const SupportLinks = ({ data }: SupportLinksProps) => {
  const mappedData = linksMapper(data);
  const { gray10, fontSemiBold, sizeExtraLarge } = useTheme();

  return mappedData.map(
    ({ title, description, links, description_id, title_id }) => (
      <Box mt={6} mb={2} key={title} border={`1px solid ${gray10}`} p={5}>
        <Box
          id={`support-page-link-title-${title_id}`}
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Box fontSize={sizeExtraLarge} fontWeight={fontSemiBold} mb={3}>
            {title}
          </Box>
        </Box>
        {description && (
          <Text paragraph id={`support-page-link-desc-${description_id}`}>
            {description}
          </Text>
        )}
        {links && <SimpleList data={links} />}
      </Box>
    )
  );
};
